// usePipelineReady - EIN Bereitschafts-Check fuer alle Transport-Aktionsflaechen:
// Ist fuer den Space eine aktive CI/CD-Pipeline da (Projekt gebunden UND
// GitHub-Token hinterlegt)? Wenn nicht, muessen Start-/Freigabe-Buttons einem
// Blocker mit Link auf die Setup-Seite weichen - das Backend lehnt Dispatches
// ohne Token ohnehin mit 400 ab, der User soll aber gar nicht erst loslaufen.
// Einmaliger Fetch pro Space (kein Polling - das macht useCicdRun nach Start).
//
// Liefert zusaetzlich den Transportweg. Im SAP-Modus faellt das Partner Directory weg: SAPs
// Transport traegt es nicht mit. Der Assistent muss das wissen, sonst waehlt der Nutzer
// Eintraege aus, sieht sie in der Zusammenfassung, der Lauf wird gruen - und im Ziel kommt
// nichts an.
import { useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

export function usePipelineReady(spaceId) {
  const [state, setState] = useState({ loading: true, ready: false, tokenSet: false, configured: false, modus: "erweitert" });

  useEffect(() => {
    if (!spaceId) { setState({ loading: false, ready: false, tokenSet: false, configured: false, modus: "erweitert" }); return; }
    let alive = true;
    const controller = new AbortController();
    setState({ loading: true, ready: false, tokenSet: false, configured: false, modus: "erweitert" });
    api(`/api/cicd/pipeline/overview?spaceId=${encodeURIComponent(spaceId)}`, { signal: controller.signal, retry: false })
      .then(r => {
        if (!alive) return;
        const tokenSet = !!r?.health?.tokenSet;
        const configured = r?.configured !== false;
        // Nur der ausdrueckliche Wert schaltet um - fehlt er, gilt der erweiterte Weg.
        const modus = r?.transportModus === "sap" ? "sap" : "erweitert";
        setState({ loading: false, tokenSet, configured, modus, canManage: r?.canManage === true, error: r?.githubError || null, ready: tokenSet && configured && !r?.githubError });
      })
      .catch(e => { if (alive) setState({ loading: false, ready: false, tokenSet: false, configured: null, modus: "erweitert", forbidden: e.status === 403, error: e.message }); });
    return () => { alive = false; controller.abort(); };
  }, [spaceId]);

  return state;
}
